import React from 'react';
import { Heart } from 'lucide-react';

export const DonateButton = () => {
    return (
        <a
            href="https://www.paypal.com/donate/?hosted_button_id=LU5K3LYRDAFV8"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-1.5 rounded-full border-2 border-[#FFC107] text-[#8D4925] bg-white transition-all transform hover:scale-105 active:scale-95 shadow-sm"
            style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
            }}
        >
            <span className="font-bold text-[14px]">Donar</span>
            <Heart className="w-4 h-4 text-[#FFC107] fill-transparent stroke-[2.5px]" />
        </a>
    );
};
